import React, { useEffect, useState } from "react";
import { Download, Mail } from "lucide-react";
import { api } from "../../lib/api";

export default function AdminNewsletter() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/admin/newsletter", { withCredentials: true }).then((r) => setSubs(r.data)); }, []);

  const exportCsv = () => {
    const csv = "email,subscribed_at\n" + subs.map((s) => `${s.email},${s.created_at}`).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = "bindni-newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-8 lg:p-12" data-testid="admin-newsletter">
      <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
        <div><p className="label-tiny text-brand-gold">Marketing</p><h1 className="font-serif-brand text-4xl text-brand-charcoal mt-1">Newsletter · {subs.length}</h1></div>
        <button onClick={exportCsv} className="btn-outline-gold flex items-center gap-2" data-testid="export-newsletter-btn"><Download size={14} /> Export CSV</button>
      </div>

      <div className="border border-brand-gold/25 bg-brand-ivory">
        <table className="w-full text-sm">
          <thead className="bg-brand-ivory-soft"><tr className="text-left label-tiny text-brand-muted"><th className="p-4">Email</th><th>Subscribed</th></tr></thead>
          <tbody>
            {subs.map((s, i) => (
              <tr key={i} className="border-t border-brand-gold/15">
                <td className="p-4 flex items-center gap-2 text-brand-charcoal"><Mail size={14} /> {s.email}</td>
                <td className="p-4 text-brand-muted">{new Date(s.created_at).toLocaleString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
